import { Component } from '@angular/core';

@Component({
  selector: 'un-top-bar',
  templateUrl: 'top-bar.component.html',
  styleUrls: ['top-bar.component.scss'],
  standalone: false,
})
export class TopBarComponent {}
